import { AdditionalTerms } from 'src/components/AdditionalTerms';
import { Link, Nowrap } from '@farmersdog/corgi-x';

export function SatisfactionTerms() {
  return (
    <AdditionalTerms title="Limited Satisfaction Guarantee for New Trial Customers">
      <p>
        At <Nowrap>The Farmer’s Dog</Nowrap>, the satisfaction of our customers
        trying our food for the first time is so important to us that we went
        ahead and guaranteed it. When you order a trial box of fresh food from
        The Farmer’s Dog for the first time, if you are not completely satisfied
        with your order, we’ll refund the full amount you paid for it.
      </p>

      <p>
        The refund will be equal to the amount paid for the trial box at the
        time of purchase, inclusive of sales tax and shipping costs (if any). If
        you received a discount on the trial box, the refund amount will reflect
        the discounted price, not the full retail price. The funds will be
        returned via the credit card used for the original purchase.
      </p>

      <p>Guarantee Limitations/Restrictions:</p>
      <ul>
        <li>
          This Guarantee applies only to first-time customers of{' '}
          <Nowrap>The Farmer’s Dog</Nowrap> that purchase a trial box of fresh
          food. Dog that purchase a trial box of fresh food.
        </li>
        <li>
          This Guarantee applies only to the first trial box and cannot be used
          for subsequent orders.
        </li>
        <li>Refunds are limited to one per household.</li>
        <li>
          <Nowrap>The Farmer’s Dog</Nowrap> reserves the right to deny refund
          requests suspected to be fraudulent or abusive at our discretion.
        </li>
        <li>
          The Guarantee does not apply to:
          <ul>
            <li>Products damaged due to improper storage or handling.</li>
            <li>Bulk or wholesale purchases.</li>
            <li>
              Subscription renewals beyond the trial box or purchases made
              through third-party platforms.
            </li>
          </ul>
        </li>
      </ul>
      <p>How to Request a Refund:</p>
      <ul>
        <li>
          Customers must request a refund within <b>14 days</b> of receiving
          their trial box.
        </li>
        <li>
          To initiate a refund, customers must contact our{' '}
          <b>Customer Support Team</b> at{' '}
          <Link to="mailto:care@thefarmersdog.com">care@thefarmersdog.com</Link>
          .
        </li>
        <li>
          Refund requests must include:
          <ul>
            <li>
              <b>Order number</b>
            </li>
            <li>
              <b>Reason for dissatisfaction</b>
            </li>
            <li>
              <b>Confirmation that the product was used as directed</b>
            </li>
          </ul>
        </li>
        <li>
          Refunds will be processed within <b>10 business days</b> after
          approval.
        </li>
      </ul>
      <p>Changes to Policy:</p>
      <p>
        <Nowrap>The Farmer’s Dog</Nowrap> reserves the right to modify or
        discontinue this Satisfaction Guarantee at any time. Any changes will be
        posted on our website and will apply to future purchases.
      </p>
    </AdditionalTerms>
  );
}
